import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";

// API REQUEST
import { FetchCoreData } from "./controllers/apirequest";

// PAGES
import Home from "./pages/Home";
import Error from "./pages/Error";
import Charges from "./pages/Charges";
import Violations from "./pages/Violations";
import HuntingZones from "./pages/HuntingZones";
import Calculator from "./pages/Calculator";
import Orders from "./pages/Orders";

// APP
export default function App() {
    const [penalCode, setPenalCode] = useState<any>({});
    const [isLoadingPenalCode, setLoadingPenalCode] = useState(false);

    // CALCULATOR DATA
    const [chargesCalculator, setChargesCalculator] = useState(JSON.parse(localStorage.getItem('chargesCalculator') ?? '[]') ?? []);
    const [violationCalculator, setViolationCalculator] = useState(JSON.parse(localStorage.getItem('violationsCalculator') ?? '[]') ?? []);

    // RUN THE PENAL CODE FETCH API ONCE
    useEffect(() => {
        FetchCoreData(setPenalCode, () => {}, setLoadingPenalCode);
    }, []);

    // EVERYTIME CHARGES CALCULATOR DATA CHANGES
    useEffect(() => {
        localStorage.setItem('chargesCalculator', JSON.stringify(chargesCalculator));
    }, [chargesCalculator]);

    // EVERYTIME VIOLATIONS CALCULATOR DATA CHANGES
    useEffect(() => {
        localStorage.setItem('violationsCalculator', JSON.stringify(violationCalculator));
    }, [violationCalculator]);

    // RETURN ELEMENT
    return (
        <Router>
            <Routes>
                <Route path='/' element={<Home />}/>
                <Route path='/home' element={<Home />}/>

                {['charges', 'laws'].map(pageName => (
                    <Route key={pageName} path={`/${pageName}`} element={
                        <Charges setChargesCalculator={setChargesCalculator} charges={penalCode['charges']} isLoading={isLoadingPenalCode} />
                    }/>
                ))}

                {['violations', 'tickets'].map(pageName => (
                    <Route key={pageName} path={`/${pageName}`} element={
                        <Violations setViolationCalculator={setViolationCalculator} violations={penalCode['tickets']} isLoading={isLoadingPenalCode} />
                    }/>
                ))}

                <Route path='/calculator' element={
                    <Calculator
                        chargesCalculator={chargesCalculator}
                        setChargesCalculator={setChargesCalculator}
                        violationCalculator={violationCalculator}
                        setViolationCalculator={setViolationCalculator}
                    />
                }/>

                <Route path='/huntingzones' element={<HuntingZones />}/>
                <Route path='/orders' element={<Orders />} />
                <Route path="*" element={<Error />} />
            </Routes>
        </Router>
    )
}
